import Income from "../models/finance/Income";
import IncomeRequest from "../models/request/IncomeRequest";
import {
  CATEGORY_ID_FILTER_PARAM,
  END_DATE_QUERY_PARAM,
  INCOMES_URL,
  START_DATE_QUERY_PARAM,
} from "../utils/constants/ApiConstants";
import { formatBackendDate } from "../utils/DateUtil";
import { httpClient } from "./http/httpClient";
import { IncomeArraySchema, IncomeSchema, validate } from "./schemas";

export async function getIncomes(categoryId?: string): Promise<Income[]> {
  const query = categoryId ? { [CATEGORY_ID_FILTER_PARAM]: categoryId } : undefined;
  const { data } = await httpClient.get<Income[]>(INCOMES_URL, { query, authenticated: true });
  return validate(IncomeArraySchema, data);
}

export async function getIncomesInRange(startDate: Date, endDate: Date): Promise<Income[]> {
  const query = {
    [START_DATE_QUERY_PARAM]: formatBackendDate(startDate),
    [END_DATE_QUERY_PARAM]: formatBackendDate(endDate),
  };
  const { data } = await httpClient.get<Income[]>(INCOMES_URL, { query, authenticated: true });
  return validate(IncomeArraySchema, data);
}

export async function deleteIncomeById(id: string): Promise<void> {
  const url = `${INCOMES_URL}/${id}`;
  await httpClient.delete<void>(url, { authenticated: true });
}

export async function createIncome(
  date: Date,
  amount: number,
  description: string,
  categoryTitle: string
): Promise<Income> {
  const payload: IncomeRequest = {
    date: formatBackendDate(date),
    amount,
    description,
    category: categoryTitle,
  };
  const { data } = await httpClient.post<Income[], IncomeRequest[]>(INCOMES_URL, [payload], { authenticated: true });
  // API returns array, but we only created one, so return the first item
  return validate(IncomeSchema, data[0]);
}

export async function updateIncome(
  id: string,
  date: Date,
  amount: number,
  description: string,
  categoryTitle: string
): Promise<Income> {
  const url = `${INCOMES_URL}/${id}`;
  const payload: IncomeRequest = {
    date: formatBackendDate(date),
    amount,
    description,
    category: categoryTitle,
  };
  const { data } = await httpClient.put<Income, IncomeRequest>(url, payload, { authenticated: true });
  return validate(IncomeSchema, data);
}


